var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1209 16.1264C15.7797 16.466 15.2272 16.4648 14.8875 16.1237L8.87634 10.0861C8.53669 9.74501 8.5379 9.19248 8.87904 8.85283C9.22018 8.51317 9.77271 8.51438 10.1124 8.85552L16.1236 14.8931C16.4632 15.2342 16.462 15.7867 16.1209 16.1264Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1363 10.099L10.0938 16.1151C9.75182 16.4556 9.20011 16.4535 8.86046 16.1124C8.52081 15.7713 8.52119 15.2195 8.86316 14.8791L14.9056 8.86296C15.2468 8.5233 15.7993 8.52451 16.139 8.86565C16.4786 9.20679 16.4774 9.75932 16.1363 10.099Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.05116 1.74419C3.82791 1.74419 1.74419 3.95 1.74419 7.36628V17.6337C1.74419 21.05 3.82791 23.2558 7.05116 23.2558H17.9488C21.1733 23.2558 23.2558 21.05 23.2558 17.6337V7.36628C23.2558 3.95 21.1733 1.74419 17.9488 1.74419H7.05116ZM17.9488 25H7.05116C2.83372 25 0 22.0395 0 17.6337V7.36628C0 2.96046 2.83372 0 7.05116 0H17.9488C22.1663 0 25 2.96046 25 7.36628V17.6337C25 22.0395 22.1663 25 17.9488 25Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7cb53088.svg";
export { ForwardRef as ReactComponent };